<template>
    <div :class="{editForm: isEdit}">
        <society-form-simple ref="form" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" @refresh="refresh" v-if="isSimple"></society-form-simple>
        <div v-else>
            <div v-if="isFull">
                <society-form-more ref="form" :isEdit="isEdit" :advise="advise" :extInfo="extInfo" @cancel="cancel" @refresh="refresh" v-if="!typeList.includes(scoreType)" :recruitType="recruitType" :scoreType="scoreType"></society-form-more>
                <society-form-recruitment-guangzhou ref="form" :advise="advise" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" v-else-if="['4', '9'].includes(scoreType)" @refresh="refresh" :recruitType="recruitType" :scoreType="scoreType"></society-form-recruitment-guangzhou>
                <society-form-recruitment-hangzhou ref="form" :advise="advise" :turn="turn" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" v-else-if="['5', '10', '17', '21', '22', '23', '24'].includes(scoreType)" @refresh="refresh" :recruitType="recruitType" :scoreType="scoreType"></society-form-recruitment-hangzhou>
                <society-form-social-notqa ref="form" :advise="advise" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" v-else-if="scoreType === '6'" @refresh="refresh" :recruitType="recruitType" :scoreType="scoreType"></society-form-social-notqa>
                <society-form-social-qa ref="form" :advise="advise" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" v-else-if="scoreType === '7'" @refresh="refresh" :recruitType="recruitType" :scoreType="scoreType"></society-form-social-qa>
                <society-form-verify-qa ref="form" :advise="advise" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" v-else-if="scoreType === '8'" @refresh="refresh" :recruitType="recruitType" :scoreType="scoreType"></society-form-verify-qa>
                <society-form-pma ref="form" :isEdit="isEdit" :extInfo="extInfo" :scoreType="scoreType" :turn="turn" v-else-if="['11', '12', '13'].includes(scoreType)" @refresh="refresh" @cancel="cancel"></society-form-pma>
                <society-form-2021-qa ref="form" :scoreType="scoreType" :turn="turn" v-else-if="['14', '15', '16', '18', '19', '20'].includes(scoreType)" :advise="advise" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" @refresh="refresh"></society-form-2021-qa>
                <society-form-simple ref="form" :advise="advise" :isEdit="isEdit" :extInfo="extInfo" @cancel="cancel" @refresh="refresh" v-else></society-form-simple>
            </div>
            <div v-else>
                <society-form ref="form" :isEdit="isEdit" :advise="advise" :extInfo="extInfo" @cancel="cancel" @refresh="refresh" v-if="scoreType"  :recruitType="recruitType"></society-form>
                <society-form-simple ref="form" :isEdit="isEdit" :advise="advise" :extInfo="extInfo" @cancel="cancel" @refresh="refresh" v-else></society-form-simple>
            </div>
        </div>
    </div>
</template>
<script>
    import SocietyFormRecruitmentGuangzhou from './society-form-2020recruitment-guangzhou'
    import SocietyFormRecruitmentHangzhou from './society-form-2020recruitment-hangzhou'
    import SocietyFormSocialQa from './society-form-social-qa'
    import SocietyFormSocialNotqa from './society-form-social-notqa'
    import SocietyFormVerifyQa from './society-form-verify-qa'
    import SocietyFormSimple from './society-form-simple.vue'
    import SocietyForm from './society-form-normal.vue'
    import SocietyFormMore from './society-form-more.vue'
    import SocietyFormPma from './society-form-pma.vue'
    import SocietyForm2021Qa from './society-form-2021-qa'
    export default {
        components: {
            SocietyFormSimple,
            SocietyFormMore,
            SocietyForm,
            SocietyFormRecruitmentGuangzhou,
            SocietyFormRecruitmentHangzhou,
            SocietyFormSocialQa,
            SocietyFormSocialNotqa,
            SocietyFormVerifyQa,
            SocietyFormPma,
            SocietyForm2021Qa
        },
        data() {
            return {
                typeList: ['4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24'],
            }
        },
        props: {
            isSimple: true,
            isFull: false,
            isEdit: false,
            advise: '',
            recruitType: null,
            scoreType: null,
            extInfo: null,
            turn: null
        },
        methods: {
            refresh () {
                this.$emit('refresh')
            },
            cancel () {
                this.$emit('cancel')
            },
            setForm (data) {
                this.$refs.form.setForm(data)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// society-form.vue?4062f1f5